<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div style="">
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增" fontSize="14px" @btnclick="adduser">
      </Commonbtn>
      <Commonbtn v-if="qx.update" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="updateclick">
      </Commonbtn>
      <Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除" fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="del">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/look.png')" title="查看详情" fontSize="14px" @btnclick="look">
      </Commonbtn>
      <!-- <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/qy.png')" title="测试" fontSize="14px" @btnclick="cs">
      </Commonbtn> -->
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" @handleSelectionChange="handleSelectionChange" ref="PublishRef"  colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" title="发布新的资讯" rigthText="发布" :dialogVisible="dialogVisibleNewInformationAdd" @cancel="cancelNewInformation" @dialogOK="dialogOKNewInformation">
      <div class="InforDialog">
        <FromComm :FromArr="FromArrs" ref="FromArrs" @selectAll="selectAll" @removeTag="removeTag" @InforSelectChange="InforSelectChange" @remoteMethod="remoteMethod"></FromComm>
        <div class="choseBtn">
          <Commonbtn btnType='btn' width="64px" height="32px" title="选择" fontSize="14px" backgroundColor="#E71D43" color="#FFF" @btnclick="chose"></Commonbtn>
        </div>
        <div class="textarea">
          <el-input type="textarea" placeholder="请输入内容" v-model="InformationtextareaAdd" show-word-limit>
          </el-input>
        </div>
        <div class="UploadFile">
          <Upload width="90px" backgroundColor="#FAFBFC" title="选择文件" :src="require('@/assets/channel/Selectfile.png')" @getFiles="SelectFile" types="files"></Upload>
          <div class="remarks">请添加附件，可添加多个，单个文件大小请勿超过20M</div>
          <div class="Top">
            <label for="text">是否置顶：</label>
            <el-checkbox v-model="IsTOP"></el-checkbox>
          </div>
		  <div class="Top" >
		    <label for="text">是否外部链接：</label>
		    <el-checkbox v-model="IsOuterLink"></el-checkbox>
		  </div>
        </div>
		<div class="textarea" v-if="IsOuterLink" >
		  <el-input placeholder="请输入外部链接" v-model="OuterLinkUrl"  />
		</div>
        <div class="UpAd">
          <CommUploadAdditional width="460px" backgroundColor="#FAFBFC" :fileData="filesInPutsArr" :srcleft="require('@/assets/channel/icon-FJ.png')" :srcright="require('@/assets/channel/del.png')"></CommUploadAdditional>
        </div>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="修改新的资讯" rigthText="修改" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="InforDialog">
        <FromComm :FromArr="FromArrs" @selectAll="selectAll" @removeTag="removeTag" @InforSelectChange="InforSelectChange" @remoteMethod="remoteMethod"></FromComm>
        <div class="choseBtn">
          <Commonbtn btnType='btn' width="64px" height="32px" title="选择" fontSize="14px" backgroundColor="#E71D43" color="#FFF" @btnclick="chose"></Commonbtn>
        </div>
        <div class="textarea">
          <el-input type="textarea" placeholder="请输入内容" v-model="InformationtextareaEdit" show-word-limit>
          </el-input>
        </div>
        <div class="UploadFile">
          <Upload width="90px" backgroundColor="#FAFBFC" title="选择文件" :src="require('@/assets/channel/Selectfile.png')" types="files" @getFiles="SelectFile"></Upload>
          <div class="remarks">请添加附件，可添加多个，单个文件大小请勿超过20M</div>
           <div class="Top">
            <label for="text">是否置顶：</label>
            <el-checkbox v-model="IsTOP"></el-checkbox>
          </div>
		  <div class="Top" >
		    <label for="text">是否外部链接：</label>
		    <el-checkbox v-model="IsOuterLink"></el-checkbox>
		  </div>
        </div>
		<div class="textarea" v-if="IsOuterLink" >
		  <el-input placeholder="请输入外部链接" v-model="OuterLinkUrl"  />
		</div>
        <div class="UpAd">
          <CommUploadAdditional width="460px" backgroundColor="#FAFBFC" :fileData="filesInPutsArr" :srcleft="require('@/assets/channel/icon-FJ.png')" :srcright="require('@/assets/channel/del.png')"></CommUploadAdditional>
        </div>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="查看详情" :dialogVisible="dialogVisibLook" @cancel="cancelLook" @dialogOK="dialogOKLook" v-if="dialogVisibLook">
      <div class="LookTop">
        <div class="LookTitle">
          {{InfoObjectData.Title}}
        </div>
        <div class="LookTime">
          {{ InfoObjectData.CreateTime }}&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;{{ InfoObjectData.CreatorName }}
        </div>
        <div class="LookContext">
          {{  InfoObjectData.InfoContent }}
        </div>
        <div class="Line">
        </div>
        <div class="Top">
          <label for="text">是否置顶：</label>
           <el-checkbox v-model="InfoObjectData.IsTOP" :disabled="true"></el-checkbox>
        </div>
		<div class="Top" >
		    <label for="text">是否外部链接：</label>
		    <el-checkbox v-model="InfoObjectData.IsOuterLink" :disabled="true" ></el-checkbox>
			<a style="margin-left: 10px;" v-if="InfoObjectData.IsOuterLink" :href="InfoObjectData.OuterLinkUrl" target="_blank" >{{InfoObjectData.OuterLinkUrl}}</a>
		</div>
        <div class="LookFile">
          <CommUploadAdditional width="450px" backgroundColor="#FAFBFC" :fileData="InfoObjectData.Attachments " :srcleft="require('@/assets/channel/icon-FJ.png')"></CommUploadAdditional>
        </div>
      </div>
    </DialogFrom>
    <DialogFrom width="800px" title="选择发送的对象" :dialogVisible="dialogVisibleObject" @cancel="cancelObject" @dialogOK="dialogOKObject">
      <div class="choiceObject">
        <div class="leftTitle">
          <div>
            选择角色/产线
          </div>
          <div class="leftTable">
            <Commontable @onRowClick555="onRowClickLeftTable" ref="choiceObjectTableleftTop" @handleSelectionChange="handleSelectionChangeleftTop" width="1000px" colnum=555 :tableData="tableDataInvClass" :headerData="headerDataInvClass" height="100%">
            </Commontable>
          </div>
          <div class="leftTable">
            <Commontable @onRowClick555="onRowClickLeftTable" width="1000px" ref="choiceObjectTableleftBottom" @handleSelectionChange="handleSelectionChangeleftBottom" colnum=555 :tableData="tableDataRole" :headerData="headerDataRole" height="100%">
            </Commontable>
          </div>
        </div>
        <div class="rightTitles">
          <div>
            选择用户
          </div>
          <div class="rightSearch">
            <SearchComm placeholder="请输入用户名称" @searchClick="searchClick" :width="205"></SearchComm>
          </div>
          <div class="rightBtn">
            <Commonbtn btnType='btn' width="100px" height="32px" :title="choseAllTitle" fontSize="14px" backgroundColor="#E71D43" color="#FFF" @btnclick="ChoseAll"></Commonbtn>
          </div>
          <div class="leftTable">
            <Commontable @onRowClick555="onRowClickLeftTable" ref="choiceObjectTableRight" @handleSelectionChange="handleSelectionChangeRight" width="1000px" colnum=555 :widthselection="90" :tableData="tableDataUser" :headerData="headerDataUser" height="100%">
            </Commontable>
          </div>
          <div class="paginationChose">
            <Pagination layout="total, prev, pager, next, jumper" @handleCurrentChange="handleCurrentChangechoiceObject" @handleSizeChange="handleSizeChangechoiceObject" :total="totalchoiceObject"></Pagination>
          </div>
        </div>
      </div>
    </DialogFrom>

    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条数据吗？</span>
    </Dialog>

  </div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import SearchComm from '../../../../components/comm-from-search.vue'
import Dialog from '../../../../components/dialog.vue'
import CommonUploadEnclosure from '../../../../components/common-upload-Enclosure.vue'
import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
import Upload from '../../../../components/common-upload'
import CommUploadAdditional from '../../../../components/comm-upload-additional.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import FromArr from '../fromData/FromArr'
import {
  InformationAdd,
  InformationEdit,
  InformationDelete,
  HelperGetUserNameAndRole,
  InformationUpLoadAttachment,
  InformationInfo
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    CommonUploadEnclosure,
    FromComm,
    Upload,
    CommUploadAdditional,
    SearchComm
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number
    }
  },
  data: function () {
    return {
	  IsOuterLink:false, //是否外部链接
	  OuterLinkUrl:'', //外部链接
      dialogVisibleNewInformationAdd: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibleqy: false,
      dialogVisibLook: false,
      dialogVisibleObject: false,
      rowboo: false,
      choseAllFlag: false,
      IsTOP: false,
      IsTOPInfo: false,
      ptype: '',
      type: '',
      zname: '',
      parentId: '',
      InfoID: '',
      InformationtextareaEdit: '',
      InformationtextareaAdd: '',
      ChoseObjectName: '',
      choseAllTitle: '全部选择',
      totalchoiceObject: 0,
      pageSize: 10,
      pageIndex: 1,
      Objects: [],
      fromdataadd: [],
      fromdataedit: [],
      FromArr: [],
      FromArrsAll: [],
      resdetailsList: {},
      qus: [],
      filesInPutsArr: [],
      ObjName: [],
      ObjectID: [],
      tableDataInvClass: [],
      invClassList: [],
      RoleList: [],
      UserList: [],
      selectData: [],
      headerDataInvClass: [
        {
          prop: 'ObjectName',
          label: '产线',
          columnwidth: 180
        },
      ],
      tableDataUser: [],
      headerDataUser: [{
        prop: 'ObjectID',
        label: '用户名',
        columnwidth: 180
      },
      {
        prop: 'ObjectName',
        label: '用户名称',
        columnwidth: 180
      },],
      tableDataRole: [],
      headerDataRole: [{
        prop: 'ObjectName',
        label: '角色',
        columnwidth: 180
      },
      ],
      InfoObjectData: null,
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false
      },
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 80
      },
      {
        prop: 'Title',
        label: '标题',
        columnwidth: 350
      },
      {
        prop: 'ObjectName',
        label: '发布对象',
        columnwidth: 470
      },
      {
        prop: 'IsTOP',
        label: '是否置顶',
        columnwidth: 150
      },
      {
        prop: 'CreateTime',
        label: '发布时间',
        columnwidth: 263
      },
      ],
      FromArrs: [
        {
          title: "",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          types: "text",
          placeholder: "请输入资讯标题",
          width: 936,
          height: 32,
          disabled: false,
          marginLeft: 5,
          marginTop: 0,
          X: false,
        },
        {
          title: "",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          types: "text",
          placeholder: "请选择发送对象(不选默认所有人)",
          width: 850,
          height: 32,
          disabled: true,
          marginLeft: 5,
          marginTop: 0,
          X: false,
        },
        // {
        //   title: "",
        //   modelvalue: [],
        //   inputtype: "selectMultiple",
        //   inputflag: true,
        //   fontSize: 14,
        //   color: "#424E66",
        //   lableheight: 5,
        //   types: "text",
        //   placeholder: "请选择发送对象(不选默认所有人)",
        //   width: 948,
        //   // height: 0,
        //   disabled: false,
        //   marginLeft: 5,
        //   marginTop: 0,
        //   X: false,
        //   event: "InforSelectChange",
        //   remoteMethod: 'PublishremoteMethod',
        //   loading: false,
        //   options: []
        // },
      ],
      FileListLook: [
        {
          fileTitle: "这里是一个附加文件1",
          rightTitle: "下载",
          color: '#E71D43'
        },
        {
          fileTitle: "这里是一个附加文件12",
          rightTitle: "下载",
          color: '#E71D43'
        },
        {
          fileTitle: "这里是一个附加文件13",
          rightTitle: "下载",
          color: '#E71D43'
        },
        {
          fileTitle: "这里是一个附加文件14",
          rightTitle: "下载",
          color: '#E71D43'
        }
      ],
      FileList: [
        {
          fileTitle: "这里是一个附加文件1"
        },
        {
          fileTitle: "这里是一个附加文件12"
        },
        {
          fileTitle: "这里是一个附加文件13"
        },
        {
          fileTitle: "这里是一个附加文件14"
        }
      ],
    }
  },
  created() {
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.QX()
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    getSingleSelectedRow(actionName) {
      if (this.selectData.length !== 1) {
        this.$message.warning(`请勾选一条数据进行${actionName}！`);
        return null;
      }
      return this.selectData[0];
    },
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        if (item.NodeID == 74) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 75) {
              this.qus = items.Nodes
            }
          })
        }
      })
      this.qus.map((item, index) => {
        if (item.NodeName == 'add') {
          this.qx.add = true
        } else if (item.NodeName == 'edit') {
          this.qx.update = true
        } else if (item.NodeName == 'delete') {
          this.qx.del = true
        } else if (item.NodeName == 'stopif') {
          this.qx.del = true
        } else if (item.NodeName == 'assignment') {
          this.qx.assignment = true
        }
      })

    },
    DataManageAddUpload() {

    },
    // 新增
    async InformationAdd() {
      let invClass = []
      let Role = []
      let User = []
      let objectInPuts = []
      //拼接格式 ==> 刘俊峰[ad1003][账号]","归创[101][产品线]",
      if (this.invClassList) {
        this.invClassList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          invClass.push(invObj)
        })
      }
      if (this.RoleList) {
        this.RoleList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          Role.push(invObj)
        })
      }
      if (this.UserList) {
        this.UserList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          User.push(invObj)
        })
      }

      objectInPuts = (invClass.concat(Role)).concat(User)
      let {
        code,
        message,
        data
      } = await InformationAdd({
        title: this.FromArrs[0].modelvalue,
        infoContent: this.InformationtextareaAdd,
        objectInPuts: this.choseAllFlag == true ? [] : objectInPuts,
        IsTOP: this.IsTOP ? 1 : 0,
        attachments: this.filesInPutsArr,
		IsOuterLink:this.IsOuterLink?1:0,
		OuterLinkUrl:this.OuterLinkUrl
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.dialogVisibleNewInformationAdd = false
        this.$parent.InformationList()
        this.$refs.PublishRef.$refs.fileTableSelect.setCurrentRow('');
        this.rowboo = false
		this.IsOuterLink = 0;
		this.OuterLinkUrl = '';
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }

    },
    // 修改
    async InformationEdit() {
      let invClass = []
      let Role = []
      let User = []
      let objectInPuts = []
      //拼接格式 ==> 刘俊峰[ad1003][账号]","归创[101][产品线]",
      if (this.invClassList) {
        this.invClassList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          invClass.push(invObj)
        })
      }
      if (this.RoleList) {
        this.RoleList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          Role.push(invObj)
        })
      }
      if (this.UserList) {
        this.UserList.map(item => {
          let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          User.push(invObj)
        })
      }
      objectInPuts = (invClass.concat(Role)).concat(User)
      // 拼接格式=>修改前的数据
       let ObjectsAll = []
      this.Objects.map(item => {
         let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
          ObjectsAll.push(invObj)
      })
      let {
        code,
        message
      } = await InformationEdit({
        infoID: this.InfoID,
        title: this.FromArrs[0].modelvalue,
        infoContent: this.InformationtextareaEdit,
        IsTOP: this.IsTOP ? 1 : 0,
        objectInPuts: this.choseAllFlag == true ? [] : (objectInPuts != '' ? objectInPuts : ObjectsAll), //如果不点击全选，就判断选择拼接之后的数据是否为空，为空就返回修改前的数据，否则返回选择拼接后的数据，如果全选传空数组就行了（根据业务而定）
        attachments: this.filesInPutsArr,
		IsOuterLink:this.IsOuterLink?1:0,
		OuterLinkUrl:this.OuterLinkUrl
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.$refs.PublishRef.$refs.fileTableSelect.setCurrentRow('');
        this.dialogVisiblesedit = false
        this.rowboo = false
        this.$parent.InformationList()
		this.IsOuterLink = 0;
		this.OuterLinkUrl = '';
      } else {
        this.$message({
          type: 'error',
          message: message
        });

      }
    },
    // 查询详情
    async InformationInfo(Status) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await InformationInfo({
        InfoID: this.InfoID
      })
      if (code == 0) {
        if (Status == 'Edit') {
          this.dialogVisiblesedit = true
          this.FromArrs[0].modelvalue = data.Title
          this.InformationtextareaEdit = data.InfoContent
          this.IsTOP = data.IsTOP == 0 ? false : true
          this.Objects = data.Objects
          let arr = []
          data.Objects.filter(item => {
            arr.push(item.ObjectName)
          })
          this.FromArrs[1].modelvalue = arr.join('、')
          this.filesInPutsArr = data.Attachments
          this.invClassList = []
          this.RoleList = []
          this.UserList = []
		  this.IsOuterLink = data.IsOuterLink?true:false;
		  this.OuterLinkUrl = data.OuterLinkUrl;
        } else if (Status == 'Info') {
          this.dialogVisibLook = true
          data.IsTOP = data.IsTOP == 0 ? false : true
          this.InfoObjectData = data
		  this.InfoObjectData.IsOuterLink =  data.IsOuterLink?true:false;
        }

      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 删除 
    async InformationDelete() {
      let {
        code,
        message
      } = await InformationDelete({
        infoID: this.InfoID,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.dialogVisibledel = false
        this.$parent.InformationList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
        this.dialogVisibledel = false
      }
    },
    onRowClick(val) {
      this.rowboo = true
      this.InfoID = val.InfoID

    },
    onRowClickLeftTable(val) {

    },
    chose() {
      this.dialogVisibleObject = true
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      setTimeout(() => {
        this.HelperGetUserNameAndRole()
        this.HelperGetUserNameAndRoleInvClass()
        this.HelperGetUserNameAndRoleUserName()
        loading.close()
      }, 100)
    },
    cancelObject() {
      this.dialogVisibleObject = false
    },
    dialogOKObject() {
      let name = []
      let arr = (this.UserList.concat(this.invClassList)).concat(this.RoleList)
      arr.map(item => {
        name.push(item.ObjectName)
      })
      this.FromArrs[1].modelvalue = name.join('、')
      this.dialogVisibleObject = false
    },
    adduser() {
	  this.IsOuterLink = 0;
	  this.OuterLinkUrl = '';
      this.dialogVisibleNewInformationAdd = true
    },
    cancelNewInformation() {
      this.dialogVisibleNewInformationAdd = false
    },
    dialogOKNewInformation() {
      this.InformationAdd()
    },
    updateclick() {
      const row = this.getSingleSelectedRow('修改');
      if (!row) return;
      this.InfoID = row.InfoID;
      this.rowboo = true;
      this.dialogVisiblesedit = true;
      this.InformationInfo('Edit');
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.InformationEdit()
    },

    look() {
      const row = this.getSingleSelectedRow('查看');
      if (!row) return;
      this.InfoID = row.InfoID;
      this.rowboo = true;
      this.InformationInfo('Info');
    },
    cancelLook() {
      this.dialogVisibLook = false
    },
    dialogOKLook() {
      this.organizationDelete()
    },
    del() {
      const row = this.getSingleSelectedRow('删除');
      if (!row) return;
      this.InfoID = row.InfoID;
      this.rowboo = true;
      this.dialogVisibledel = true;
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.InformationDelete()
    },
    handleCurrentChange(PageIndex) {
      this.$emit('handleCurrentChange', PageIndex)
    },
    handleSizeChange(PageSize) {
      this.$emit('handleSizeChange', PageSize)
    },
    handleChange() {

    },
    // 上传文件
    async SelectFile(file) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let formdata = new FormData()
      for (var i = 0; i < file.length; i++) {
        formdata.append("files", file[i]);
      }
      let {
        data,
        code,
        message
      } = await InformationUpLoadAttachment(formdata)
      if (code == 0) {
        this.$message({
          type: 'success',
          message: message
        });
        data.forEach((item, index) => {
          this.filesInPutsArr.push(item)
        })
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
      loading.close();
    },
    // 发送用户接口-用户名
    async HelperGetUserNameAndRoleUserName() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await HelperGetUserNameAndRole({
        name: this.ChoseObjectName,
        ObjectType: 'UserName',
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (code == 0) {
        this.tableDataUser = []
        // this.UserList = []
        this.totalchoiceObject = data.Count
        this.tableDataUser = data.data
        if (this.Objects) {
          this.Objects.map(item => {
            if (item.ObjectType == "账号") {
              this.UserList.push(item)
            }
          })
        }
        let userArr = []
        this.$nextTick(() => {
          this.UserList.forEach((item, index) => {
            this.tableDataUser.forEach((items, indexs) => {
              if (item.ObjectName == items.ObjectName) {
                userArr.push(item)
                this.$refs.choiceObjectTableRight.$refs.fileTable555.toggleRowSelection(items, true);
              }
            })
          })
        })
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    // 发送用户接口-角色
    async HelperGetUserNameAndRole() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await HelperGetUserNameAndRole({
        ObjectType: 'Roles',
      })
      if (code == 0) {
        this.tableDataRole = []

        this.tableDataRole = data.data
        if (this.Objects) {
          this.Objects.map(item => {
            if (item.ObjectType == "角色") {
              this.RoleList.push(item)
            }
          })
        }
        let userArr = []
        this.$nextTick(() => {
          this.RoleList.forEach((item, index) => {
            this.tableDataRole.forEach((items, indexs) => {
              if (item.ObjectName == items.ObjectName) {
                userArr.push(item)
                this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.toggleRowSelection(items, true);
              }
            })
          })
        })
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    // 发送用户接口-产线
    async HelperGetUserNameAndRoleInvClass() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await HelperGetUserNameAndRole({
        ObjectType: 'InvClass',
      })
      if (code == 0) {
        this.dialogVisibleObject = true
        this.tableDataInvClass = []
        // this.invClassList = []
        this.tableDataInvClass = data.data
        if (this.Objects) {
          this.Objects.map(item => {
            if (item.ObjectType == "产品线") {
              this.invClassList.push(item)
            }
          })
          let userArr = []
          this.$nextTick(() => {
            this.invClassList.forEach((item, index) => {
              this.tableDataInvClass.forEach((items, indexs) => {
                if (item.ObjectName == items.ObjectName) {
                  userArr.push(item)
                  this.$refs.choiceObjectTableleftTop.$refs.fileTable555.toggleRowSelection(items, true);
                }
              })
            })
          })
        }

      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    handleSelectionChangeleftTop(val) {
      this.invClassList = val
    },
    handleSelectionChangeleftBottom(val) {
      this.RoleList = val
    },
    handleSelectionChangeRight(val) {
      this.UserList = val
    },
    choseInfo() {
      this.$nextTick(() => {
        for (let i = 0; i < this.tableDataInvClass.length; i++) {
          this.$refs.choiceObjectTableleftTop.$refs.fileTable555.toggleRowSelection(this.tableDataInvClass[i], true);
        }
        for (let i = 0; i < this.tableDataRole.length; i++) {
          this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.toggleRowSelection(this.tableDataRole[i], true);
        }
        for (let i = 0; i < this.tableDataUser.length; i++) {
          this.$refs.choiceObjectTableRight.$refs.fileTable555.toggleRowSelection(this.tableDataUser[i], true);
        }
      })
    },
    // 全选
    ChoseAll() {
      this.choseAllFlag = !this.choseAllFlag
      if (this.choseAllFlag) {
        this.choseAllTitle = '取消选择'
        this.$nextTick(() => {
          for (let i = 0; i < this.tableDataInvClass.length; i++) {
            this.$refs.choiceObjectTableleftTop.$refs.fileTable555.toggleRowSelection(this.tableDataInvClass[i], true);
          }
          for (let i = 0; i < this.tableDataRole.length; i++) {
            this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.toggleRowSelection(this.tableDataRole[i], true);
          }
          for (let i = 0; i < this.tableDataUser.length; i++) {
            this.$refs.choiceObjectTableRight.$refs.fileTable555.toggleRowSelection(this.tableDataUser[i], true);
          }
        })
      } else {
        this.choseAllTitle = '全部选择'
        this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
        this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
        this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
      }
    },
    remoteMethod(val) {
      if (val.parsign == 'PublishremoteMethod') {
        this.HelperGetUserNameAndRole(val.qurey)
      }
    },
    searchClick(val) {
      this.ChoseObjectName = val
      this.HelperGetUserNameAndRoleUserName()
    },
    // // 全选
    selectAll() {
      if (this.FromArrs[1].modelvalue.length < this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue = []
        this.FromArrs[1].options.map((item) => {
          this.FromArrs[1].modelvalue.push(item.value)
        })
        this.FromArrs[1].modelvalue.unshift('全选')
      } else {
        this.FromArrs[1].modelvalue = []
      }
    },
    // 多选的Change事件
    InforSelectChange(e) {
      if (!e.FromArr[1].modelvalue.includes('全选') && e.FromArr[1].modelvalue.length === this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue.unshift('全选')
      } else if (e.FromArr[1].modelvalue.includes('全选') && (e.FromArr[1].modelvalue.length - 1) < this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue = this.FromArrs[1].modelvalue.filter((item) => {
          return item !== '全选'
        })
      }
    },
    // 删除全选选项全部删除
    removeTag(val) {
      if (val === '全选') {
        this.FromArrs[1].modelvalue = []
      }
    },
    handleCurrentChangechoiceObject(pageIndex) {
      this.pageIndex = pageIndex
      this.HelperGetUserNameAndRoleUserName()
    },
    handleSizeChangechoiceObject(pageSize) {
      this.pageSize = PageSize
      this.HelperGetUserNameAndRoleUserName()
    },
  },
  watch: {
    dialogVisiblesedit: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.FromArrs.map((item, index) => {
            if (index == 0) {
              item.modelvalue = [];
            }
            item.modelvalue = '';
          })
          this.filesInPutsArr = [];
          this.ObjName = [];
          this.ObjectID = [];
          this.InfoObjectData = null;
          this.InformationtextareaEdit = '';
           this.IsTOP = false
          // this.RoleList = []
          // this.UserList = []
          // this.invClassList = []
          // this.Objects = []
        }
      }
    },
    dialogVisibleNewInformationAdd: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.FromArrs.map((item, index) => {
            if (index == 0) {
              item.modelvalue = [];
            }
            item.modelvalue = '';
          })
          this.filesInPutsArr = [];
          this.ObjName = [];
          this.ObjectID = [];
          this.InformationtextareaAdd = '';
          this.IsTOP = false
          // this.RoleList = []
          // this.UserList = []
          // this.invClassList = []
          try {
            this.choseAllFlag = false
            this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
            this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
            this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
          } catch (error) {

          }
          this.Objects = []
        } else {
          this.RoleList = []
          this.UserList = []
          this.invClassList = []
        }
      }
    },
    dialogVisibleObject: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          try {
            this.choseAllFlag = false
            // this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
            // this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
            // this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
          } catch (error) {

          }
        } else {

        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // flex-wrap: wrap;
  }
}
.InforDialog {
  max-height: 632px;
  overflow-y: scroll;

  .choseBtn {
    position: absolute;
    top: 105px;
    left: 900px;
  }
}
.textarea {
  margin-top: 16px;
}
.UploadFile {
  margin-left: -5px;

  .Top{
    display: inline-block;
    margin-left: 120px;
  }
}

.remarks {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #9ca5b8;
}

/deep/.el-input__inner {
  width: calc(100% - 5px);
  height: 34px;
  margin-left: 5px;
}
/deep/.el-input__inner:focus {
  border: 1px solid #e71d43;
}
/deep/.el-input__inner:hover {
  border: 1px solid #e71d43;
}

/deep/.el-textarea__inner {
  height: 300px;
  width: 946px;
  margin-left: 5px;
}
/deep/.el-textarea__inner:focus {
  border: 1px solid #e71d43;
}
/deep/.el-textarea__inner:hover {
  border: 1px solid #e71d43;
}
.choiceObject {
  width: 946px;
  height: 100%;
  // border: 1px solid red;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  color: #333333;
  line-height: 20px;

  .leftTitle {
    width: 230px;
    font-size: 14px;

    overflow: hidden;

    .leftTable {
      margin-left: -10px;
      margin-top: 20px;
    }
  }
  .paginationChose {
    position: relative;
    right: 60px;
    top: 50px;
  }
  .rightTitles {
    width: 710px;
    font-size: 14px;

    .rightSearch {
      position: relative;
      top: -45px;
      left: -350px;
    }
    .rightBtn {
      position: absolute;
      top: 50px;
      left: 650px;
    }
    .leftTable {
      margin-left: -10px;
      margin-top: 20px;
    }
  }
}
.LookTop {
  width: 946px;
  height: 100%;
  // border: 1px solid red;
  margin: 0 auto;
  .Top{
    display: inline-block;
    margin-top: 20px;
    margin-left: 5px;
  }

  .LookTitle {
    height: 34px;
    font-size: 24px;
    font-weight: normal;
    color: #16181a;
    text-align: center;
  }
  .LookTime {
    height: 20px;
    font-size: 14px;
    font-weight: normal;
    color: #9ca5b7;
    text-align: center;
    margin-top: 10px;
  }
  .LookContext {
    width: 936px;
    font-size: 16px;
    font-weight: normal;
    color: #424e66;
    white-space: pre-wrap;
    margin-top: 50px;
  }
  p {
    margin-top: 49px;
  }
  .Line {
    width: 930px;
    height: 1px;
    background-color: #f2f3f5;
    margin-top: 24px;
    display: inline-block;
  }
  .LookFile {
    margin-top: 20px;
  }
}
</style>
